import React, { useEffect, useState } from 'react';
import { useForm } from '@mantine/form';
import { TextInput, Button, Group, Title, Select, Text, Stack, MultiSelect, NumberInput, Switch } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCheck } from '@tabler/icons-react';
import { getLevels, getProvinces, getGenders, getUserTypes, saveNotification } from '../../services/api.service';
import EmojiPopover from '../popovers/EmojiPopover';
import { DateTimePicker } from '@mantine/dates';

const NotificationForm = ({ closeModal }) => {

	// Hooks
	const [isLoading, toggleLoading] = useState(false);
	const [levels, setLevels] = useState([]);
	const [provinces, setProvinces] = useState([]);
	const [genders, setGenders] = useState([]);
	const [userTypes, setUserTypes] = useState([]);
	const [showSchedule, toggleShowSchedule] = useState(false);
	const form = useForm({
		initialValues: {
			message: {
				payload: {
					notification: {
						title: '',
						body: '',
					}
				}
			},
			options: {
				ageMin: '',
				ageMax: '',
				genderId: '',
				provinceId: '',
				levelId: '',
				userTypeId: ''
			},
			segmentations: [],
			scheduled: null,
		},
	});
	const segmentationOptions = [
		{
			value: 'level',
			label: 'Nivel'
		},
		{
			value: 'age',
			label: 'Rango Etario'
		},
		{
			value: 'type',
			label: 'Tipo Biker'
		},
		{
			value: 'gender',
			label: 'Género'
		},
		{
			value: 'state',
			label: 'Provincia'
		},
	];

	// On load
	useEffect(() => {

		// Get levels
		getLevels(function (response) {

			// Loop levels
			var levels = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				levels.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});

			}

			// Set state
			setLevels(levels);

		}, function (error) {

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

		// Get provinces
		getProvinces(function (response) {

			// Loop provinces
			var provinces = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				provinces.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});

			}

			// Set state
			setProvinces(provinces);

		}, function (error) {

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

		// Get genders
		getGenders(function (response) {

			// Loop genders
			var genders = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				genders.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});

			}

			// Set state
			setGenders(genders);

		}, function (error) {

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

		// Get user types
		getUserTypes(function (response) {

			// Loop user types
			var userTypes = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				userTypes.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});

			}

			// Set state
			setUserTypes(userTypes);

		}, function (error) {

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

	}, []);

	// Submit form
	const onSubmit = (values) => {

		// Create object
		const formValues = {
			message: values.message,
			scheduled: values.scheduled,
			options: Object.entries(values.options).reduce((acc, [key, value]) => {
				if (value !== "" && value !== null) {
				  acc[key] = value;
				}
				return acc;
			}, {})
		};

		// Set loader
		toggleLoading(true);

		// Call API
		saveNotification(formValues, function () {

			// Show success
			notifications.show({
				title: 'Notificación creada correctamente',
				color: 'green',
				icon: <IconCheck />
			});

			// Close after 1 second
			setTimeout(() => {

				// Close modal
				closeModal();

			}, 1000);

		}, function (error) {

			// Remove preloader
			toggleLoading(false);

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

	}

	return (
		<form onSubmit={form.onSubmit(onSubmit)}>
			{/* Title */}
			<Title
				order={5}
				mb="md"
			>
				Información de la Notificación
			</Title>
			{/* Input Group */}
			<Group
				grow
				mt="md"
			>
				{/* Title */}
				<Stack spacing={2}>
					{/* Input */}
					<TextInput
						required
						label="Título"
						placeholder="Título de la notificación"
						value={form.values.message.payload.notification.title}
						onChange={(event) => form.setFieldValue('message.payload.notification.title', event.currentTarget.value)}
						{...form.getInputProps('message.payload.notification.title')}
						maxLength={65}
						rightSection={
							<EmojiPopover
								onSelect={(val) => form.setFieldValue('message.payload.notification.title', form.values.message.payload.notification.title + ' ' + val.native)}
							/>
						}
					/>
					{/* Counter */}
					<Text
						fz={12}
						fw={700}
						c="dimmed"
						align="right"
					>
						{65 - form.values.message.payload.notification.title.length} caracteres restantes
					</Text>
				</Stack>
				{/* Description */}
				<Stack spacing={2}>
					{/* Input */}
					<TextInput
						required
						label="Descripción"
						placeholder="Descripción de la notificación"
						value={form.values.message.payload.notification.body}
						onChange={(event) => form.setFieldValue('message.payload.notification.body', event.currentTarget.value)}
						{...form.getInputProps('message.payload.notification.body')}
						maxLength={130}
						rightSection={
							<EmojiPopover
								onSelect={(val) => form.setFieldValue('message.payload.notification.body', form.values.message.payload.notification.body + ' ' + val.native)}
							/>
						}
					/>
					{/* Counter */}
					<Text
						fz={12}
						fw={700}
						c="dimmed"
						align="right"
					>
						{130 - form.values.message.payload.notification.body.length} caracteres restantes
					</Text>
				</Stack>
			</Group>
			{/* Input Group */}
			<Group mt="xs">
				{/* Segmentation */}
				<MultiSelect
					withinPortal
					required
					label="Segmentación"
					placeholder="Segmentar notificación por"
					{...form.getInputProps('segmentations')}
					data={segmentationOptions}
					style={{ flex: 2 }}
				/>
			</Group>
			{/* Selected Segmentations */}
			<Group
				mt="md"
				grow
			>
				{/* Level ID */}
				{form.values.segmentations.includes('level') ?
					<Select
						searchable
						withinPortal
						required
						label="Nivel"
						placeholder="Busca un nivel"
						value={form.values.options.levelId}
						onChange={(event) => form.setFieldValue('options.levelId', event.currentTarget.value)}
						{...form.getInputProps('options.levelId')}
						nothingFound="Sin resultados"
						data={levels}
						miw={300}
					/>
				: null}
				{/* Age */}
				{form.values.segmentations.includes('age') ?
					<Group noWrap>
						<NumberInput
							min={0}
							max={99}
							required
							label="Edad desde"
							placeholder="0"
							value={form.values.options.ageMin}
							onChange={(event) => form.setFieldValue('options.ageMin', event.currentTarget.value)}
							{...form.getInputProps('options.ageMin')}
							miw={100}
						/>
						<NumberInput
							min={0}
							max={99}
							required
							label="Edad hasta"
							placeholder="99"
							value={form.values.options.ageMax}
							onChange={(event) => form.setFieldValue('options.ageMax', event.currentTarget.value)}
							{...form.getInputProps('options.ageMax')}
							miw={100}
						/>
					</Group>
				: null}
				{/* Province ID */}
				{form.values.segmentations.includes('state') ?
					<Select
						searchable
						withinPortal
						required
						label="Provincia"
						placeholder="Busca una provincia"
						value={form.values.options.provinceId}
						onChange={(event) => form.setFieldValue('options.provinceId', event.currentTarget.value)}
						{...form.getInputProps('options.provinceId')}
						nothingFound="Sin resultados"
						data={provinces}
						miw={300}
					/>
				: null}
				{/* Gender ID */}
				{form.values.segmentations.includes('gender') ?
					<Select
						searchable
						withinPortal
						required
						label="Género"
						placeholder="Busca un género"
						value={form.values.options.genderId}
						onChange={(event) => form.setFieldValue('options.genderId', event.currentTarget.value)}
						{...form.getInputProps('options.genderId')}
						nothingFound="Sin resultados"
						data={genders}
						miw={300}
					/>
				: null}
				{/* User Type ID */}
				{form.values.segmentations.includes('type') ?
					<Select
						searchable
						withinPortal
						required
						label="Tipo Biker"
						placeholder="Busca un tipo de biker"
						value={form.values.options.userTypeId}
						onChange={(event) => form.setFieldValue('options.userTypeId', event.currentTarget.value)}
						{...form.getInputProps('options.userTypeId')}
						nothingFound="Sin resultados"
						data={userTypes}
						miw={300}
					/>
				: null}
			</Group>
			{/* Scheduled */}
			<Group mt="md">
				{/* Schedule On/Off */}
				<Switch
					label="Programar"
					checked={showSchedule}
					onChange={(event) => toggleShowSchedule(event.currentTarget.checked)}
				/>
				{/* Date */}
				{showSchedule ?
					<DateTimePicker
						required
						label="Fecha de Programación"
						placeholder="Elige una fecha"
						valueFormat="DD-MM-YYYY HH:mm"
						value={form.values.scheduled}
						onChange={(event) => form.setFieldValue('scheduled', event.currentTarget.value)}
						{...form.getInputProps('scheduled')}
						dropdownType="modal"
						modalProps={{
							withinPortal: true,
							centered: true
						}}
						style={{ flex: 2 }}
					/>
				: null}
			</Group>
			{/* Buttons */}
			<Group
				position="apart"
				grow
			>
				{/* Cancel */}
				<Button
					mt="xl"
					color="red"
					onClick={closeModal}
					disabled={isLoading}
					variant="light"
				>
					Cancelar
				</Button>
				{/* Submit */}
				<Button
					mt="xl"
					type="submit"
					loading={isLoading}
					variant="filled"
				>
					Crear Notificación
				</Button>
			</Group>
		</form>
	);

}

export default NotificationForm;
